export const validationTranslation = {
    es : {
        note: 'Pago no aprobado',
        title: 'Verifica la información',
        subtitle: 'No se pudo completar la compra, verifica los siguientes datos e intenta de nuevo ',
        buttonText: 'Intentar otra vez',
        footerText : 'Si tienes problemas con tu pago, contacta a <a href="mailto:vivafan@vivaaerobus.com"> Servicio al cliente </a>',

        number: 'El número de tarjeta es el correcto ',
        cardExp: 'Fecha de vencimiento de la tarjeta',
        ccv: 'Número de CVV correcto',
        month: 'Mes de las tarjetas',
        year:  'Año de la tarjeta',
        firstName :  'El nombre del titular coincide con el que aparece en tu tarjeta ',
        lastName : 'El nombre del titular coincide con el que aparece en tu tarjeta ',
        country : "La dirección de facturación corresponde al país registrado a la tarjeta ",
        bbva: "Asegúrate de usar tu tarjeta digital al pagar con BBVA",
        city: "La dirección de facturación corresponde al cuidad registrado a la tarjeta ",
        insufficient_funds: "Su transacción fue declinada por fondos insuficientes en su cuenta. Por favor use una tarjeta diferente o comuníquese con su banco.",
        canceled_account: "Cuenta: no se puede comprar en una cuenta cancelada",
        unknown: "El banco ha rechazado la transacción, por favor, póngase en contacto con ellos para más detalles o intente utilizar otra tarjeta."
    
    },
    eng : {
        note: 'Payment not approved',
        title: 'Check the information',
        subtitle: 'Please make sure the following information is correct:',
        buttonText: 'Try again',
        footerText : 'If you have problems with your payment contact us to help you <a href="mailto:vivafan@vivaaerobus.com"> vivafan@vivaaerobus.com </a>',
        number: 'Card number',
        cardExp: 'Card expiration date',
        ccv: 'CVV number',
        month: 'Card Month',
        year:  'Card Year',
        firstName :  `The cardholder's name is the one that appears on the card.`,
        lastName : `The cardholder's last name is the one that appears on the card.`,
        country : "Country",
        city: "City",
        insufficient_funds: "Your transaction was declined due to insufficient funds in your account. Please use a different card or contact your bank.",
        canceled_account: "Account: cannot purchase on canceled account",
        unknown: "The bank has declined the transaction, please contact them for details or try using another card."
    }
}